import React from "react";
import FormTip from "../commons/warning_tip";

const ModalInterviewAnswer = (props) => { 
  const icon =  require("../../images/diff.svg");

  return (
    <div id="modalInterviewAnswer" className="modal fade" role="dialog">
      <div className="modal-dialog">
        <div className="modal-content bg-subscreen">
          <div className="modal-header question-title">
            <button type="button" className="close" data-dismiss="modal">&times;</button>
            <h4 className="modal-title">{props.patientName} 様の先確認内容</h4>
            <div className="mt5 felx_center">
              <img src={icon} className="mr5 pointer"/>マークが表示されてる場合、前回の回答内容と差異があります。<br/>
            </div>
            <div className="mt5 felx_center">
              画像データは比較対象外となります。<br/>
            </div>
          </div>
          <div className="modal-body">
            {props.interviewCategories.length === 0 ?
              (
                <>
                  Loading...
                </>
              ):(
                <>
                  { props.interviewCategories.map((category)=>{
                    return(
                        <table className="table table-bordered table-noborder">
                          <thead className="interview-table-head">
                            <tr>
                              <th colSpan={3}>{category.categoryName}</th>
                            </tr>
                          </thead>
                          <tbody className="interview-table">
                            { props.interviewQuestions.map((question) => {
                              return(
                                <>
                                  {
                                    question.partGroupId === category.partGroupId && (
                                      <>
                                        {props.interviewAnswers[question.questionNumber].answers.map((answer, i) => {
                                          return (
                                            i === 0 ? (
                                              <>
                                                <tr>
                                                  <td className="col-md-3 col-sm-3 col-xs-3" rowSpan={props.interviewAnswers[question.questionNumber].answers.length}>
                                                    {question.shortTitle}
                                                  </td>
                                                  <td className="col-md-8 col-sm-8 col-xs-8">
                                                  {
                                                    answer.imgValue.length == 0 ? (
                                                      answer.is_answer_different ? (
                                                        <FormTip description={answer.previous_answer.label}>
                                                          {answer.label}
                                                        </FormTip>
                                                      ) : (
                                                          answer.label
                                                      )
                                                    ) : (
                                                      answer.imgValue.map((img_value) =>{
                                                      return(
                                                        <a href={img_value.imgPath} data-lightbox={`interview_${question.questionNumber}_${i}`} data-title={question.shortTitle}>
                                                          <img className="col-md-12 img-thumbnail" src={img_value.imgPath}/>
                                                        </a>
                                                      )
                                                      })
                                                    ) 
                                                  }
                                                  </td>
                                                </tr>                                                        
                                              </>
                                            ):(
                                              <>
                                                <tr>
                                                  <td className="col-md-8 col-sm-8 col-xs-8">
                                                    {
                                                      answer.imgValue.length == 0 ? (
                                                        answer.is_answer_different ? (
                                                          <FormTip description={answer.previous_answer.label}>
                                                            {answer.label}
                                                          </FormTip>
                                                        ):(
                                                          answer.label
                                                        )
                                                      ) : (
                                                        answer.imgValue.map((img_value) =>{
                                                        return(
                                                          <a href={img_value.imgPath} data-lightbox={`interview_${question.questionNumber}_${i}`}  data-title={question.shortTitle}>
                                                            <img className="col-md-12 img-thumbnail" src={img_value.imgPath}/>
                                                          </a>
                                                        )
                                                        })
                                                      ) 
                                                    }
                                                  </td>
                                                </tr>  
                                              </>
                                            )
                                          )
                                        })}
                                      </>
                                    ) 
                                  }

                                </>  
                              )
                            })}
                          </tbody>
                        </table>
                    )
                  })}
                </>
              )
            }

           
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-default" data-dismiss="modal">閉じる</button>
          </div>
        </div>
      </div>  
    </div>  
  );
};

export default ModalInterviewAnswer;